const start =
  `当前环境:${process.env.NODE_ENV === 'development' ? '开发环境' : '生产环境'}\n
            ____ ____
    ____   / __// __/_____ ____
   / __ \\ / /_ / /_ / ___// __ \\
  / /_/ // __// __// /__ / / / /
  \\____//_/  /_/   \\___//_/ /_/`
console.log(start)
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import AntComponent from 'ant-design-vue'
// 全屏插件
import fullscreen from 'vue-fullscreen'

/* 自定义工具类 */
import myUtils from '@/utils/index'
/* 全局样式 */
import './less/variables.less'
/* 全局组件 xx */

Vue.use(AntComponent)
Vue.use(fullscreen)
Vue.use(myUtils)

/* 全局注册 */
Vue.config.productionTip = false
Vue.config.devtools = false

/* 全局变量 */
Vue.prototype.APP_VERSION = process.env.VUE_APP_VERSION
Vue.prototype.APP_UPDATE = process.env.VUE_APP_UPDATE
/* 上传地址 */
Vue.prototype.UPLOAD_URL = process.env.NODE_ENV === 'development'
  ? process.env.VUE_APP_DEVELOPMENT_URL + '/api/v1/upload'
  : process.env.VUE_APP_PRODUCTION_URL + '/api/v1/upload'

/**
 * 路由回跳
 */
Vue.prototype.goBack = () => { router.go(-1)}

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')

